import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FileUpload } from '../../models/file.upload.interface';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file.upload.component.html',
  styleUrls: ['./file.upload.component.scss']
})
export class FileUploadComponent {

  @Input() accept: string;

  @Input() fileBytes?: string;
  @Output() fileBytesChange = new EventEmitter<string | undefined>();

  @Input() importFile?: any;
  @Output() importFileChange = new EventEmitter<any | undefined>();

  @ViewChild('fileInput') fileInput: ElementRef;
  fileAttr = $localize`No file chosen`;

  // Maximum file size allowed to
  // be uploaded = 10MB
  MAX_SIZE: number = 10048576;

  uploadFile: any;
  message: string = '';

  constructor() {
  }

  onFileChange(event: any) {
    this.uploadFile = null;
    this.message = '';
    this.fileAttr = $localize`No file chosen`;

    this.importFile = undefined;
    this.importFileChange.emit(this.importFile);

    this.fileBytes = undefined;
    this.fileBytesChange.emit(this.fileBytes);

    if (event.target.files && event.target.files.length > 0) {
      // Don't allow file sizes over 1MB
      if (event.target.files[0].size < this.MAX_SIZE) {
        // Set theFile property
        this.loadFile(event.target.files[0]);
      }
      else {  // Display error message
        let filename = 'event.target.files[0].name';
        this.message = $localize`File: ${filename} is too large to upload.`;
      }

    }
  }

  loadFile(file: any) {
    this.fileAttr = file.name;

    this.importFile = file;
    this.importFileChange.emit(this.importFile);

    // HTML5 FileReader API
    let reader = new FileReader();
    reader.onload = (e: any) => {
      // Store base64 encoded representation of file
      this.fileBytes = reader.result.toString();
      this.fileBytesChange.emit(this.fileBytes);
    };
    reader.readAsDataURL(file);
  }
}
